import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNPatient } from 'src/app/models/cnpatient';
import { ServicesService } from 'src/app/services/services.service';

@Component({
  selector: 'app-contact-user-services-dialog',
  templateUrl: './contact-user-services-dialog.component.html',
  styleUrls: ['./contact-user-services-dialog.component.scss']
})
export class ContactUserServicesDialogComponent implements OnInit {

  public patient: CNPatient;
  public location: string;

  constructor(private dialogRef: MatDialogRef<ContactUserServicesDialogComponent>, @Inject(MAT_DIALOG_DATA) data,
              private services: ServicesService) {
    if (typeof data.patient !== 'undefined') {
      this.patient = data.patient;
    }
    if (typeof data.location !== 'undefined') {
      this.location = data.location;
    }
  }

  ngOnInit(): void {
  }
}
